import React from 'react';
import Home from './components/Home';
import Intros from './components/Intros';
import Projects from './components/Projects'; 
import Experience from "./components/Experience";
import Connect from "./components/Connect";
import './css/all.css';
function App() {
  return (
    <div className="App">
       <Home></Home>
       <Intros></Intros>
       <Experience></Experience>
       <Projects></Projects>
       <Connect></Connect>
     
    </div>
  );
}

export default App;
